console.log('[Video] script loaded');

const inlinePlayers = new WeakMap();
let modalPlayer = null;
let youtubeAPIReady = false;
const isMobile = /Mobi|Android/i.test(navigator.userAgent);

function onYouTubeIframeAPIReady() {
  youtubeAPIReady = true;
  console.log('[Video] YouTube API is ready');
}

function openVideoInline(playBtn) {
  console.log('[Video] openVideoInline called');
  const videoId = playBtn.dataset.videoId;
  const videoBlock = playBtn.closest('.video-block');
  if (!videoBlock) return console.warn('[Video] No .video-block parent found');

  const container = videoBlock.querySelector('[data-player]');
  const pauseBtn = videoBlock.querySelector('.custom-pause-btn');
  if (!container || !videoId || !youtubeAPIReady) {
    if (!youtubeAPIReady) console.warn('[Video] YouTube API not ready yet');
    return;
  }

  let pauseFadeTimeout;
  function fadeInPause() {
    pauseBtn.style.visibility = 'visible';
    pauseBtn.style.opacity = '0';
    requestAnimationFrame(() => {
      pauseBtn.style.transition = 'opacity 400ms linear';
      pauseBtn.style.opacity = '1';
    });
  }
  function hidePause() {
    clearTimeout(pauseFadeTimeout);
    pauseBtn.style.transition = 'opacity 200ms linear';
    pauseBtn.style.opacity = '0';
    setTimeout(() => { pauseBtn.style.visibility = 'hidden'; }, 200);
  }
  function showPlay() {
    playBtn.style.visibility = 'visible';
    playBtn.style.opacity = '1';
  }
  function hidePlay() {
    playBtn.style.transition = 'opacity 0';
    playBtn.style.opacity = '0';
    playBtn.style.visibility = 'hidden';
  }

  if (isMobile) {
    function createOrPlayMobile() {
      if (inlinePlayers.has(container)) {
        videoBlock.classList.add('loading');
        inlinePlayers.get(container).playVideo();
      } else {
        videoBlock.classList.add('loading');
        const player = new YT.Player(container, {
          height: '460',
          width: '100%',
          videoId,
          playerVars: { autoplay:1, controls:1, modestbranding:1, rel:0, fs:1, disablekb:1, iv_load_policy:3, playsinline:1 },
          events: {
            onReady: e => e.target.playVideo(),
            onStateChange: e => {
              switch (e.data) {
                case YT.PlayerState.PLAYING:
                  videoBlock.classList.remove('loading');
                  videoBlock.classList.add('playing');
                  fadeInPause();
                  break;
                case YT.PlayerState.PAUSED:
                  setTimeout(() => {
                    if (inlinePlayers.get(container).getPlayerState() === YT.PlayerState.PAUSED) {
                      // videoBlock.classList.remove('playing');
                      // hidePause();
                      // showPlay();
                      // videoBlock.classList.remove('mobile-active');
                    }
                  }, 200);
                  break;
                case YT.PlayerState.ENDED:
                  videoBlock.classList.remove('playing');
                  hidePause();
                  showPlay();
                  videoBlock.classList.remove('mobile-active');
                  break;
              }
            }
          }
        });
        inlinePlayers.set(container, player);
      }
    }

    if (!playBtn._mobileHandlerAttached) {
      playBtn.addEventListener('click', () => {
        hidePlay();
        videoBlock.classList.add('mobile-active');
        createOrPlayMobile();
      });
      playBtn._mobileHandlerAttached = true;
    }
    if (!pauseBtn._mobilePauseAttached) {
      pauseBtn.addEventListener('click', () => {
        inlinePlayers.get(container)?.pauseVideo();
        videoBlock.classList.remove('playing');
        hidePause();
        showPlay();
      });
      pauseBtn._mobilePauseAttached = true;
    }
    return;
  }

  function createOrPlayDesktop() {
    if (inlinePlayers.has(container)) {
      inlinePlayers.get(container).loadVideoById(videoId);
      inlinePlayers.get(container).playVideo();
    } else {
      const player = new YT.Player(container, {
        height: '460',
        width: '640',
        videoId,
        playerVars: { controls:1, modestbranding:1, rel:0, fs:1, disablekb:1, iv_load_policy:3, playsinline:1 },
        events: {
          onReady: e => e.target.playVideo(),
          onStateChange: e => {
            switch (e.data) {
              case YT.PlayerState.PLAYING:
                videoBlock.classList.add('playing');
                videoBlock.classList.remove('loading');
                hidePlay();
                pauseFadeTimeout = setTimeout(fadeInPause, 1000);
                break;
              case YT.PlayerState.PAUSED:
                setTimeout(() => {
                  if (inlinePlayers.get(container).getPlayerState() === YT.PlayerState.PAUSED) {
                    // videoBlock.classList.remove('playing');
                    // hidePause();
                    // showPlay();
                  }
                }, 200);
                break;
              case YT.PlayerState.ENDED:
                videoBlock.classList.remove('playing');
                hidePause();
                showPlay();
                break;
            }
          }
        }
      });
      inlinePlayers.set(container, player);
    }
  }

  if (!playBtn._desktopHandlerAttached) {
    playBtn.addEventListener('click', () => {
      hidePlay();
      videoBlock.classList.add('loading');
      createOrPlayDesktop();
    });
    playBtn._desktopHandlerAttached = true;
  }
  if (!pauseBtn._desktopPauseAttached) {
    pauseBtn.addEventListener('click', () => {
      inlinePlayers.get(container)?.pauseVideo();
      videoBlock.classList.remove('playing');
      hidePause();
      showPlay();
    });
    pauseBtn._desktopPauseAttached = true;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  console.log('[Video] DOMContentLoaded');

  document.querySelectorAll('.open-video-btn').forEach(button => {
    button.addEventListener('click', function () {
      const videoId = this.dataset.videoId;
      if (this.hasAttribute('data-modal')) {
        openVideoModal(videoId);
      } else {
        openVideoInline(this);
      }
    });
  });

  document.querySelector('.video-modal__close')?.addEventListener('click', closeVideoModal);
  document.querySelector('.video-modal__overlay')?.addEventListener('click', closeVideoModal);

  // SECTION CLOSE BUTTON
  document.querySelectorAll('.section-close-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const section = btn.closest('.video-section');
      const iframe  = section.querySelector('iframe');
      if (iframe) {
        iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
      }
      section.style.display = 'none';
    });
  });
});

let modalIsReady = false;
let pendingVideoId = null;

function openVideoModal(videoId) {
  const modal = document.getElementById('video-modal');
  modal.classList.add('active');
  pendingVideoId = videoId;
  if (!youtubeAPIReady) return console.warn('[Video] YouTube API not ready for modal');

  if (modalPlayer && modalIsReady) {
    modalPlayer.loadVideoById(videoId);
    modalPlayer.playVideo();
  } else if (!modalPlayer) {
    modalPlayer = new YT.Player('youtube-player-modal', {
      height: '460',
      width: '640',
      videoId,
      playerVars: { autoplay:1, controls:1, modestbranding:1, rel:0, fs:1, disablekb:1, iv_load_policy:3, playsinline:1 },
      events: {
        onReady: e => {
          modalIsReady = true;
          if (pendingVideoId) {
            e.target.loadVideoById(pendingVideoId);
            e.target.playVideo();
            pendingVideoId = null;
          }
        },
        onStateChange: e => {
          if (e.data === YT.PlayerState.ENDED) {
            document.getElementById('video-modal').classList.remove('active');
            //e.target.stopVideo();
          }
        }
      }
    });
  }
}

function closeVideoModal() {
  const modal = document.getElementById('video-modal');
  modal.classList.remove('active');
  modalPlayer?.stopVideo();
}